import { reactive } from "vue";

export const store = reactive({
  canvas: null,
  canvasCopy: null,
  brightness: 0.6,
  frequency: 0.9,
  amplitude: 0.5,
  velocity: 5,
  color: [200, 200, 200],
  bgColor: [100, 50, 200],
  transparency: false,
  imageDimension: "800x800",
  videoDuration: 2000,
  rounded: false
});
